import { connect } from 'react-redux';
import * as moment from 'moment';
import { find, sortBy } from 'lodash';
import * as queryString from 'query-string';
import BaseForm from '../BaseForm/BaseForm';
import {
  addReservation,
  showError,
  clearErrors,
} from '../../redux/actions/reservations';
import RESERVATION_TYPES from '../../data/reservationTypes';
import CONDITION_TYPES from '../../data/conditions';

class ReservationCreateForm extends BaseForm {
  constructor(props) {
    super(props, {
      onSubmit: addReservation,
      name: 'Reservation',
      action: 'Add',
      type: 'create',
      isTypeForm: false,
    });
  }

  /**
   * Handle form validation
   */
  handleValidate(data, isIndex = (index: number) => true) {
    let newName;
    if (this.props.model.didInvalidate) {
      this.props.dispatch(clearErrors());
    }
    if (isIndex(0) && BaseForm.validator.isEmpty(data.name)) {
      const vehicle: any = find(this.props.values.vehicle_id, {
        value: Number(data.vehicle_id),
      });
      newName = vehicle.name;
    }
    if (isIndex(1) && !BaseForm.validator.isNumeric(data.vehicle_id)) {
      this.props.dispatch(showError('Please specify a vehicle'));
      return false;
    }
    if (isIndex(2) && BaseForm.validator.isEmpty(data.start_date)) {
      this.props.dispatch(showError('Please specify a start date'));
      return false;
    }
    if (isIndex(3) && BaseForm.validator.isEmpty(data.end_date)) {
      this.props.dispatch(showError('Please specify an end date'));
      return false;
    }
    const start = moment(`${data.start_date} 00:00:00`);
    if (!start.isValid()) {
      this.props.dispatch(showError('The start date is not in a valid format'));
      return false;
    }
    const end = moment(`${data.end_date} 23:59:59`);
    if (!end.isValid()) {
      this.props.dispatch(showError('The end date is not in a valid format'));
      return false;
    }
    if (!end.isSameOrAfter(start)) {
      this.props.dispatch(
        showError("Make sure the reservation's end is after the start"),
      );
      return false;
    }
    return {
      name: newName ? newName : data.name,
      vehicle_id: data.vehicle_id,
      start: start.format('YYYY-MM-DD HH:mm:ss'),
      end: end.format('YYYY-MM-DD HH:mm:ss'),
      description: data.description,
      type: data.type,
      condition: data.condition,
    };
  }

  /**
   * Handle form reset
   */
  handleReset(dispatch, actions) {
    const query = queryString.parse(window.location.search);
    dispatch(actions.change('create.name', ''));
    dispatch(
      actions.change(
        'create.start_date',
        query && query.start_date ? query.start_date : '',
      ),
    );
    dispatch(
      actions.change(
        'create.end_date',
        query && query.end_date ? query.end_date : '',
      ),
    );
    dispatch(
      actions.change(
        'create.vehicle_id',
        query && query.vehicle_id ? query.vehicle_id : '',
      ),
    );
    dispatch(actions.change('create.description', ''));
  }
}

const mapStateToProps = ({
  reservations,
  vehicles,
  vehicleTypes,
  history,
}) => ({
  model: reservations,
  fields: BaseForm.fields.reservations.create,
  values: {
    vehicle_id: sortBy(vehicles.vehicles, 'vehicle_type_id').map((vehicle) => {
      let name = vehicle.registration;
      const type: any = find(vehicleTypes.vehicleTypes, {
        id: vehicle.vehicle_type_id,
      });
      if (type !== undefined) {
        name += ` (${type.name})`;
      }
      return {
        name,
        value: vehicle.id,
      };
    }),
    type: RESERVATION_TYPES,
    condition: CONDITION_TYPES,
  },
});

export default connect(mapStateToProps)(ReservationCreateForm);
